<template>
  <div v-if="superUser || canViewHR">
    <!-- Tabs for Payroll Sections -->
    <div class="tabs-container d-flex justify-content-center mt-2">
      <button class="btn btn-primary me-2" :class="{ active: activeTab === 'employees' }"
        @click="activeTab = 'employees'">
        Payroll Costs Εργαζομένων
      </button>
      <button class="btn btn-primary me-2" :class="{ active: activeTab === 'departments' }"
        @click="activeTab = 'departments'">
        Payroll Costs Λειτουργικών
      </button>
      <button class="btn btn-primary" :class="{ active: activeTab === 'related' }" @click="activeTab = 'related'">
        Payroll Related Costs
      </button>
    </div>

    <!-- Specialties CRUD Section -->
    <div v-if="activeTab === 'employees'" class="form-section mt-3">
      <!-- Container for title and button -->
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 style="font-weight: bolder; color: #555555">Payroll Costs Εργαζομένων</h5>
        </div>

        <!-- Right-aligned category selection -->
        <div class="d-flex align-items-center">
          <h5 style="font-weight: bolder; color: #555555; margin-right: 10px;">Επιλέξτε Κατηγορία</h5>
          <div class="dropdown">
            <select v-model="selectedCategory" class="form-select">
              <!--<option value="">Όλες</option> -->
              <option v-for="(title, id) in categoryTitles" :key="id" :value="id">
                {{ title }}
              </option>
            </select>
          </div>
        </div>

        <div>
          <h5 style="font-weight: bolder; color: #555555">
            ΣΥΝΟΛΟ: {{ formatNumber(employeeExpenses) }}
            <span> €</span>
          </h5>
        </div>
      </div>

      <!-- Specialties List (Grouped by Category) -->
      <div v-if="filteredSpecialties.length > 0" class=" mt-4">
        <div v-for="(specialtiesByCategory, categoryId) in groupedSpecialties" :key="categoryId">
          <div class="row">
            <div v-for="(specialty, index) in specialtiesByCategory" :key="specialty.id"
              class="col-md-3 card shadow-custom p-3 mb-3 bg-white rounded position-relative">
              <!-- Non-Editable View -->
              <div v-if="!editStates[specialty.id]">
                <div class="row" style="color:#A6A6A6; font-weight:bolder">
                  <div class="col-md-12">
                    <p class="label-with-circle">
                      <strong>{{ specialty.title }}</strong>
                      <hr />
                    </p>
                    <div class="col-md-12">
                      <p>
                        <strong>Αριθμός εργαζομένων: {{ specialty.number_of_employees }}</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p>
                        <strong>Ημέρες εργασίας: {{ specialty.working_days }}</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p><strong>Ώρες Εργασίας:</strong> {{ specialty.working_hours }}</p>
                    </div>
                    <div class="col-md-12">
                      <p>
                        <strong>Συνολικοί Μήνες Εργασίας: {{ formatNumber(specialty.total_working_months) }}</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p>
                        <strong>Μήνες εργασίας (Operation): {{ formatNumber(specialty.working_months_operation)
                          }}</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p><strong>Μήνες εργασίας (Off Season):</strong> {{
                        formatNumber(specialty.working_months_off_season) }}</p>
                    </div>

                    <div class="col-md-12">
                      <p>
                        <strong>Δώρα/Επιδόματα: {{ formatNumber(specialty.benefits) }}</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p>
                        <strong>Μικτός Μηνιαίος Μισθός: {{ formatNumber(specialty.monthly_gross_salary) }}€</strong>
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p><strong>Καθαρός Μηνιαίος Μισθός:</strong> {{ formatNumber(specialty.monthly_net_salary) }}€</p>
                    </div>

                    <div class="col-md-12">
                      <p>
                        <strong>Μηνιαίο Μισθοδοτικό Κόστος: {{ formatNumber(specialty.monthly_payment_salary)
                          }}€</strong>
                      </p>
                    </div>
                    <div class="col-md-12 mt-3">
                      <div class="card shadow-sm bg-light rounded">
                        <h6 class="text-primary" style="font-weight: bold; text-decoration: underline;">Συνολικό
                          Μισθοδοτικό Κόστος</h6>
                        <div class="row">
                          <div class="col-md-6">
                            <p>
                              <strong>Καθαρά:</strong> {{ formatNumber(specialty.total_payment_salary_net) }}€
                            </p>
                            <p>
                              <strong>Operation:</strong> {{ formatNumber(specialty.total_payment_salary_operation) }}€
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <strong>Off Season:</strong> {{ formatNumber(specialty.total_payment_salary_off_season)
                              }}€
                            </p>
                            <p>
                              <strong>Έτους:</strong> {{ formatNumber(specialty.total_payment_salary) }}€
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="action-buttons">
                    <button class="btn border-0 p-1 edit" @click="editSpecialty(specialty)">
                      <img src="../assets/images/edit-budget.png" alt="Edit" width="30">
                    </button>
                  </div>
                </div>
              </div>

              <!-- Editable View (Inline) -->
              <div v-else>
                <div class="row">
                  <div class="col-md-12">
                    <p class="label-with-circle2">
                      <strong>{{ specialty.title }}</strong>
                      <hr />
                    </p>
                  </div>
                  <div class="col-md-8 form-group">
                    <p>
                      <strong>Αριθμός εργαζομένων</strong>
                      <hr />
                    </p>
                    <input type="number" v-model="specialty.number_of_employees" class="form-control" required />
                  </div><br>

                  <div class="col-md-8 form-group mt-2">
                    <p>
                      <strong>Ημέρες εργασίας</strong>
                      <hr />
                    </p>
                    <input type="number" v-model="specialty.working_days" class="form-control" required />
                  </div><br>

                  <div class="col-md-8 form-group mt-2">
                    <p>
                      <strong>Ώρες εργασίας</strong>
                      <hr />
                    </p>
                    <input type="number" v-model="specialty.working_hours" class="form-control" required />
                  </div><br>

                  <div class="col-md-8 form-group mt-2">
                    <p>
                      <strong>Συνολικοί Μήνες Εργασίας</strong>
                      <hr />
                    </p>
                    <input type="text" v-model="specialty.total_working_months" class="form-control" required
                      @input="formatDecimalInput($event, 'total_working_months')" />
                  </div><br>

                  <div class="col-md-8 form-group mt-2">
                    <p>
                      <strong>Μικτός Μηνιαίος Μισθός</strong>
                      <hr />
                    </p>
                    <input type="text" v-model="specialty.monthly_gross_salary" class="form-control" required
                      @input="formatDecimalInput($event, 'monthly_gross_salary')" />
                  </div><br>
                </div>

                <div class="row form-actions mt-4">
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-secondary justify-content-end align-items-end"
                      @click="cancelEditSpecialty(specialty)">
                      ΑΚΥΡΩΣΗ
                    </button>
                  </div>
                </div>

                <!-- Form Actions -->
                <div class="action-buttons">
                  <button class="btn border-0 p-1 save" @click="openSpecialtySaveModal($event, specialty)">
                    <img src="../assets/images/save.png" alt="Save" width="30">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payroll Related Costs -->
    <div v-if="activeTab === 'related'" class="form-section mt-4">
      <!-- Container for title and button -->
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h5 style="font-weight: bolder; color: #555555">Payroll Related Costs</h5>
        </div>


        <div>
          <h5 style="font-weight: bolder; color: #555555">
            ΣΥΝΟΛΟ: {{ formattedBudgetRelatedCosts }}
            <span v-if="budgetTotalRelated"> €</span>
          </h5>
        </div>
      </div>


      <!-- Specialties List (Grouped by Category) -->
      <div class="row">
        <div class="col-md-10 card shadow-custom p-3 mb-3 bg-white rounded position-relative">
          <!-- Non-Editable View -->
          <div v-if="!isEditingRelatedCosts">
            <div class="row" style="color:#A6A6A6; font-weight:bolder">
              <!-- Total Number of Employees -->
              <div class="col-md-12 mb-4">
                <p>
                  <strong>Συνολικός Αριθμός Εργαζομένων: {{ payrollRelatedCosts.total_number_of_employees }}</strong>
                </p>
                <p>
                  <strong>Ημέρες εργασίας ανά βδομάδα: {{ workingDays }}</strong>
                </p>
              </div>

              <!-- Accommodation and Clothing Costs -->
              <div class="col-md-6">
                <!-- Accommodation Section -->
                <div class="row">
                  <div class="col-4">
                    <p><strong>Κόστος Διαμονής:</strong></p>
                  </div>
                  <div class="col-8">
                    <p><strong>Ανάγκες Στέγασης - KPIs: {{ payrollRelatedCosts.cost_of_accomondation_food_needs
                        }}</strong></p>
                    <p><strong>Μέσο Κόστος Διαμονής - KPIs: {{ payrollRelatedCosts.cost_of_accomondation_average
                        }} €</strong></p>
                    <p><strong>Συνολικό Κόστος Διαμονής: {{
                      formatNumber(payrollRelatedCosts.cost_of_accomondation_total) }} €</strong></p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <!-- Clothing Section -->
                <div class="row">
                  <div class="col-4">
                    <p><strong>Κόστος Ένδυσης:</strong></p>
                  </div>
                  <div class="col-8">
                    <p><strong>Ανάγκες Ένδυσης - KPIs: {{ payrollRelatedCosts.cost_of_clothing_needs }} </strong></p>
                    <p><strong>Μέσο Κόστος Ένδυσης - KPIs: {{ payrollRelatedCosts.cost_of_clothing_average }} €</strong>
                    </p>
                    <p><strong>Συνολικό Κόστος Ένδυσης: {{ formatNumber(payrollRelatedCosts.cost_of_clothing_total) }}
                        €</strong></p>

                  </div>
                </div>
              </div>


              <!-- Edit Button -->
              <div class="action-buttons text-end mt-3">
                <button class="btn border-0 p-1 edit" @click="editRelatedCosts()">
                  <img src="../assets/images/edit-budget.png" alt="Edit" width="30">
                </button>
              </div>
            </div>
          </div>

          <!-- Editable View (Inline) -->
          <div v-else>
            <div class="row" style="color:#A6A6A6; font-weight:bolder">
              <!-- Total Number of Employees -->
              <div class="col-md-12 mb-4">
                <p>
                  <strong>Συνολικός Αριθμός Εργαζομένων: {{ payrollRelatedCosts.total_number_of_employees }}</strong>
                </p>
              </div>

              <!-- Working Days per Week (Editable) -->
              <div class="col-md-12 mb-4">
                <div class="row">
                  <div class="col-4">
                    <p><strong>Ημέρες Εργασίας ανά Βδομάδα:</strong></p>
                  </div>
                  <div class="col-2">
                    <select v-model="workingDays" class="form-control">
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Accommodation and Clothing Costs -->
              <div class="col-md-6">
                <!-- Accommodation Section -->
                <div class="row mb-3">
                  <div class="col-4 mb-5">
                    <p><strong>Κόστος Διαμονής:</strong></p>
                  </div>
                  <div class="col-8">
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Ανάγκες Στέγασης - KPIs:</strong>
                      <input type="text" v-model="payrollRelatedCosts.cost_of_accomondation_food_needs"
                        class="form-control" required />
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Μέσο Κόστος Διαμονής - KPIs:</strong>
                      <input type="text" v-model="payrollRelatedCosts.cost_of_accomondation_average"
                        class="form-control" required />
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Συνολικό Κόστος Διαμονής:</strong>
                      <input disabled :value="formatNumber(payrollRelatedCosts.cost_of_accomondation_total) + ' €'"
                        class="form-control" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <!-- Clothing Section -->
                <div class="row mb-3">
                  <div class="col-4 mb-5">
                    <p><strong>Κόστος Ένδυσης:</strong></p>
                  </div>
                  <div class="col-8">
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Ανάγκες Ένδυσης - KPIs:</strong>
                      <input type="text" v-model="payrollRelatedCosts.cost_of_clothing_needs" class="form-control"
                        required />
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Μέσο Κόστος Ένδυσης - KPIs:</strong>
                      <input type="text" v-model="payrollRelatedCosts.cost_of_clothing_average" class="form-control"
                        required />
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <strong class="me-2" style="width:100%">Συνολικό Κόστος Ένδυσης:</strong>
                      <input disabled :value="formatNumber(payrollRelatedCosts.cost_of_clothing_total) + ' €'"
                        class="form-control" />

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-actions mt-4">
              <div class="d-flex justify-content-end">
                <button class="btn btn-secondary justify-content-end align-items-end" @click="cancelEditRelatedCosts()">
                  ΑΚΥΡΩΣΗ
                </button>
              </div>
            </div>

            <!-- Form Actions -->
            <div class="action-buttons">
              <button class="btn border-0 p-1 save" @click="openRelatedCostsSaveModal($event)">
                <img src="../assets/images/save.png" alt="Save" width="30">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div v-if="activeTab === 'departments'" class="form-section mt-3">
    <!-- Container for title and button -->
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <h5 style="font-weight: bolder; color: #555555">Payroll Costs Λειτουργικών</h5>
      </div>

      <!-- Right-aligned category selection -->
      <div class="d-flex align-items-center">
        <h5 style="font-weight: bolder; color: #555555; margin-right: 10px;">Επιλέξτε Κατηγορία</h5>
        <div class="dropdown">
          <select v-model="selectedDepartmentCategory" class="form-select">
            <!--<option value="">Όλες</option> -->
            <option v-for="(title, id) in departmentCategoryTitles" :key="id" :value="id">
              {{ title }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <h5 style="font-weight: bolder; color: #555555">
          ΣΥΝΟΛΟ: {{ formattedBudgetDepartmentCosts }}
          <span> €</span>
        </h5>
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-md-11 card shadow-custom mb-3 bg-white rounded position-relative">
        <div v-if="operationalCategory.title == 'RECEPTION'">
          <div v-if="!isEditingOperationalCategory">
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle">
                  <strong>{{ operationalCategory.title }}</strong>
                </p>
              </div>
              <!-- <div class="col-md-4 text-end">
                  <p>
                    <strong>Σύνολο Kόστους:</strong> €
                  </p>
                </div> -->
              <hr /><br>


              <div class="col-md-4">
                <p>
                  <strong>Παραδοχή (Χ Δωμάτια εξυπηρέτησης/1 υπάλληλο Υποδοχής): {{ operationalCategory.assumption
                    }}</strong>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>KPIs: {{ formatNumber(operationalCategory.KPIs) }}</strong>
                </p>
              </div>

              <!-- <div class="table-responsive mb-4">
                      <table class="table table-bordered text-center">
                        <thead class="table-dark">
                          <tr>
                            <th></th>
                            <th>ΚΑΤΑΝΟΜΗ</th>
                            <th v-for="expenseMonth in revenue.expenses" :key="expenseMonth.id">
                              {{ getMonthName(expenseMonth.date_from) }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>ΠΡΩΪΝΑ</strong></td>
                            <td>{{ revenue.assumption_breakfast_kouver }}%</td>

                            <td v-for="expenseMonth in revenue.expenses" :key="'bb-' + expenseMonth.id">
                              {{ expenseMonth.allocation_breakfast_kouver }}
                            </td>
                          </tr>
                          <tr>
                            <td><strong>ΜΕΣΗΜΕΡΙΑΝΑ</strong></td>
                            <td>{{ revenue.assumption_lunch_kouver }}%</td>

                            <td v-for="expenseMonth in revenue.expenses" :key="'hb-' + expenseMonth.id">
                              {{ expenseMonth.allocation_lunch_kouver }}
                            </td>
                          </tr>
                          <tr>
                            <td><strong>ΒΡΑΔΥΝΑ</strong></td>
                            <td>{{ revenue.assumption_dinner_kouver }}%</td>

                            <td v-for="expenseMonth in revenue.expenses" :key="'fb-' + expenseMonth.id">
                              {{ expenseMonth.allocation_dinner_kouver }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->

            </div>

            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editOperationalCategory()">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30" />
              </button>
            </div>
          </div>

          <div v-else>
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle2">
                  <strong style="color:black">{{ operationalCategory.title }}</strong>
                </p>
              </div>
              <!-- <div class="col-md-4 text-end">
                  <p>
                    <strong>Σύνολο Kόστους:</strong> {{ formatNumber(expense.total_fnb_cost) }} €
                  </p>
                </div> -->


            </div>
            <hr /><br>

            <div class="row align-items-center">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <p class="mb-0 flex-70"><strong>Παραδοχή (Χ Δωμάτια εξυπηρέτησης/1 υπάλληλο Υποδοχής):</strong></p>
                  <input type="text" v-model="operationalCategory.assumption" class="form-control flex-30"
                    placeholder="Παραδοχή (Χ Δωμάτια εξυπηρέτησης/1 υπάλληλο Υποδοχής)" />
                </div>
              </div>
            
            </div>

           
          </div>
        </div>
        <div v-if="operationalCategory.title == 'HOUSEKEEPING'">
          <div v-if="!isEditingOperationalCategory">
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle">
                  <strong>{{ operationalCategory.title }}</strong>
                </p>
              </div>
        
              <hr /><br>


              <div class="col-md-4">
                <p>
                  <strong>Παραδοχή (Χ Δωμάτια καθαρισμού/1 υπάλληλο Ορόφων): {{ operationalCategory.assumption
                    }}</strong>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>KPIs: {{ formatNumber(operationalCategory.KPIs) }}</strong>
                </p>
              </div>
            </div>

            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editOperationalCategory()">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30" />
              </button>
            </div>
          </div>

          <div v-else>
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle2">
                  <strong style="color:black">{{ operationalCategory.title }}</strong>
                </p>
              </div>
            


            </div>
            <hr /><br>

            <div class="row align-items-center">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <p class="mb-0 flex-70"><strong>Παραδοχή (Χ Δωμάτια καθαρισμού/1 υπάλληλο Ορόφων):</strong></p>
                  <input type="text" v-model="operationalCategory.assumption" class="form-control flex-30"
                    placeholder="Παραδοχή (Χ Δωμάτια καθαρισμού/1 υπάλληλο Ορόφων)" />
                </div>
              </div>
              
            </div>

          
          </div>
        </div>
        <div v-if="operationalCategory.title == 'FOOD & BEVERAGE'">
          <div v-if="!isEditingOperationalCategory">
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle">
                  <strong>{{ operationalCategory.title }}</strong>
                </p>
              </div>
      
              <hr /><br>


              <div class="col-md-4">
                <p>
                  <strong>Παραδοχή (Χ Κουβέρ/1 σερβιτόρο): {{ operationalCategory.assumption
                    }}</strong>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>KPIs: {{ formatNumber(operationalCategory.KPIs) }}</strong>
                </p>
              </div>

            </div>

            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editOperationalCategory()">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30" />
              </button>
            </div>
          </div>

          <div v-else>
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle2">
                  <strong style="color:black">{{ operationalCategory.title }}</strong>
                </p>
              </div>
            
            </div>
            <hr /><br>

            <div class="row align-items-center">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <p class="mb-0 flex-70"><strong>Παραδοχή (Χ Κουβέρ/1 σερβιτόρο):</strong></p>
                  <input type="text" v-model="operationalCategory.assumption" class="form-control flex-30"
                    placeholder="Παραδοχή (Χ Κουβέρ/1 σερβιτόρο)" />
                </div>
              </div>
             
            </div>

            
          </div>
        </div>
        <div v-if="operationalCategory.title == 'KITCHEN'">
          <div v-if="!isEditingOperationalCategory">
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle">
                  <strong>{{ operationalCategory.title }}</strong>
                </p>
              </div>
             
              <hr /><br>


              <div class="col-md-4">
                <p>
                  <strong>Παραδοχή (Χ Κουβέρ/1 μάγειρα): {{ operationalCategory.assumption
                    }}</strong>
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>KPIs: {{ formatNumber(operationalCategory.KPIs) }}</strong>
                </p>
              </div>

            </div>

            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editOperationalCategory()">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30" />
              </button>
            </div>
          </div>

          <div v-else>
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
              <div class="col-md-8">
                <p class="label-with-circle2">
                  <strong style="color:black">{{ operationalCategory.title }}</strong>
                </p>
              </div>
            


            </div>
            <hr /><br>

            <div class="row align-items-center">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <p class="mb-0 flex-70"><strong>Παραδοχή (Χ Κουβέρ/1 μάγειρα):</strong></p>
                  <input type="text" v-model="operationalCategory.assumption" class="form-control flex-30"
                    placeholder="Παραδοχή (Χ Κουβέρ/1 μάγειρα)" />
                </div>
              </div>
          
            </div>

          </div>
        </div>
        <form id="dataForm">
          <div class="table-responsive">
            <h5 class="fw-bolder text-center">KATANOMΗ ΜΕΡΟΚΑΜΑΤΩΝ</h5>
            <table class="table table-bordered text-center">
              <thead class="table-dark">
                <tr>
                  <th></th>
                  <th>ΜΕΡΟΚΑΜΑΤΑ ΑΝΟΙΓΜΑΤΟΣ</th>
                  <th v-for="expenseMonth in payrollDepartmentCosts.category?.payroll_costs_categories"
                    :key="expenseMonth.id">
                    {{ getMonthName(expenseMonth?.date_from) }}
                  </th>
                  <th>ΜΕΡΟΚΑΜΑΤΑ ΚΛΕΙΣΙΜΑΤΟΣ</th>
                  <th v-if="!isEditingOperationalCategory">ΕΤΟΣ</th>
                  <th>Μέσο Μισθοδοτικό κόστος</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Μηναία Μεροκάματα του τμήματος: <b>{{ operationalCategory.title }}</b></td>
                  <td><b>{{ formatNumber(payrollDepartmentCosts.category?.total_wages_open) }}</b></td>
                  <td v-for="payrollCost in payrollDepartmentCosts.category?.payroll_costs_categories ?? []"><b>{{
                    formatNumber(payrollCost?.total_wages) }}</b></td>
                  <td><b>{{ formatNumber(payrollDepartmentCosts.category?.total_wages_close) }}</b></td>
                  <td v-if="!isEditingOperationalCategory"><b>{{ formatNumber(getTotalWagesDepartment()) }}</b></td>
                  <td>-</td>

                </tr>
                <tr v-for="payrollCost1 in payrollDepartmentCosts.specialties">
                  <td>{{ payrollCost1.title }}</td>
                  <td>
                    <span v-if="!isEditingOperationalCategory">{{ formatNumber(payrollCost1.wages_open)}}</span>
                    <input type="number" v-if="isEditingOperationalCategory" v-model="dataForm[payrollCost1.id].wages_open"  class="form-control" />
                  </td>
                  <td v-for="payrollCost2 in payrollCost1.payroll_costs_specialties">
                    <span v-if="!isEditingOperationalCategory">{{ formatNumber(payrollCost2.wages) }}</span>
                    <input type="number" v-if="isEditingOperationalCategory && dataForm[payrollCost1.id]" v-model="dataForm[payrollCost1.id].months[getMonthDigit(payrollCost2.date_from)]" class="form-control" />
                  </td>

                  <td>
                    <span v-if="!isEditingOperationalCategory">{{ payrollCost1.wages_close}}</span>
                    <input type="number" v-if="isEditingOperationalCategory" v-model="dataForm[payrollCost1.id].wages_close" class="form-control" />
                  </td>
                  <td v-if="!isEditingOperationalCategory"><b>{{ formatNumber(getTotalWages(payrollCost1)) }}</b></td>

                  <td>
                    <span v-if="!isEditingOperationalCategory">{{ formatNumber(payrollCost1.average_salary) }} &euro;</span>
                    <input type="text" v-if="isEditingOperationalCategory" v-model="dataForm[payrollCost1.id].average_salary" class="form-control" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <div class="row form-actions mt-4" v-if="isEditingOperationalCategory">
              <div class="d-flex justify-content-end">
                <button class="btn btn-secondary justify-content-end align-items-end"
                  @click="cancelEditOperationalCategory()">
                  ΑΚΥΡΩΣΗ
                </button>
              </div>
            </div>

            <div class="action-buttons-save" v-if="isEditingOperationalCategory">
              <button class="btn border-0 p-1 save2" @click="confirmSaveOperationalCategory()">
                <img src="../assets/images/save.png" alt="Save" width="30" />
              </button>
            </div>
      </div>
    </div>
  </div>

  <!-- Save Confirmation Modal for Specialties -->
  <div class="modal fade" id="specialtySaveModal" tabindex="-1" aria-labelledby="specialtySaveModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="specialtySaveModalLabel">Επιβεβαίωση Αποθήκευσης</h5>
          <button type="button" class="close" @click="closeSpecialtySaveModal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">Είστε σίγουροι ότι θέλετε να αποθηκεύσετε τα δεδομένα;</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeSpecialtySaveModal">Ακύρωση</button>
          <button type="button" class="btn btn-primary" @click="confirmSaveSpecialty">Αποθήκευση</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="relatedSaveModal" tabindex="-1" aria-labelledby="relatedSaveModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="specialtySaveModalLabel">Επιβεβαίωση Αποθήκευσης</h5>
          <button type="button" class="close" @click="closeRelatedSaveModal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">Είστε σίγουροι ότι θέλετε να αποθηκεύσετε τα δεδομένα;</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeRelatedSaveModal">Ακύρωση</button>
          <button type="button" class="btn btn-primary" @click="confirmSaveRelatedCosts">Αποθήκευση</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import { useToast } from 'vue-toastification';
import { reactive } from 'vue';

import { fetchBudgetInfo, fetchUsers, changeUser, fetchUserInfo } from '../services/user';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import {
  getCategories,
  getSpecialties,
  updateSpecialty,
  getDepartmentCategories,
  getPayrollDepartmentCosts,
  getOperationalCategory,
  updateOperationalCategoryPayrollCost
} from '@/services/payroll_cost_specialties';

import {
  getBudget,
  updatePayrollRelatedCosts,
} from '@/services/budget';
import { getDepartmentExpenses, getEmployeeExpenses } from '@/services/expenses';

export default {
  name: 'EmployeeSpecialties',
  methods: {
   
   ...mapActions(['fetchUserData']),

 },
 computed: {
   ...mapGetters({
     getUserPermission: 'getUserPermission',
     getSuperUserPermission: 'getSuperUserPermission',
     getUserRoles: 'getUserRoles'

   }),
   getTotalWages() {
  return (payrollCost1) => {
    if (!payrollCost1 || !Array.isArray(payrollCost1.payroll_costs_specialties)) return 0;

    // Sum all monthly wages
    const totalMonths = payrollCost1.payroll_costs_specialties.reduce((sum, month) => {
      return sum + (month?.wages || 0);
    }, 0);

    // Add ΜΕΡΟΚΑΜΑΤΑ ΑΝΟΙΓΜΑΤΟΣ and ΜΕΡΟΚΑΜΑΤΑ ΚΛΕΙΣΙΜΑΤΟΣ
    const total = totalMonths + (payrollCost1.wages_open || 0) + (payrollCost1.wages_close || 0);

    return total;
  };
},


   superUser() {
           return this.getSuperUserPermission === 1;
       },
       canViewSales() {
           return this.getUserRoles.includes(1);
       },
   canViewFnB() {
           return this.getUserRoles.includes(2);
       },
       canViewHR() {
           return this.getUserRoles.includes(3);
       },
       canViewOperational() {
           return this.getUserRoles.includes(4);
       },
       // Filter specialties based on selected category
    filteredSpecialties() {
      if (!this.selectedCategory) return this.specialties;
      return this.specialties.filter(specialty => specialty.employee_category_id == this.selectedCategory);
    },

    formattedBudgetTotal() {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.budgetTotalEmployees);
    },
    formattedBudgetRelatedCosts() {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.budgetTotalRelated);
    },
    formattedBudgetDepartmentCosts() {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.departmentExpenses);
    },

    // Grouped specialties based on category
    groupedSpecialties() {
      return this.filteredSpecialties.reduce((acc, specialty) => {
        const categoryId = specialty.employee_category_id;
        if (!acc[categoryId]) {
          acc[categoryId] = [];
        }
        acc[categoryId].push(specialty);
        return acc;
      }, {});
    }
 },
 
  data() {
    return {
      employeeExpenses: null,
      departmentExpenses: null,
      dataForm: reactive({}),
      payrollDepartmentCosts: [],
      operationalCategory: {},
      isEditingOperationalCategory: false,
      activeTab: 'employees', // Default tab
      showCategoryForm: false,
      showForm: false,
      isEditingSpecialty: false,
      isEditingRelatedCosts: false,
      showSpecialtySaveModal: false, // Modal for saving specialties
      showDeleteSpecialtyModal: false, // Modal for deleting specialties
      showCategorySaveModal: false, // Modal for saving categories
      showDeleteCategoryModal: false, // Modal for deleting categories
      categoryForm: {
        title: '',
      },
      form: {
        title: '',
        employee_category_id: null,
      },
      categories: [],
      specialties: [],
      payrollRelatedCosts: {
        cost_of_accomondation_food_needs: '',
        cost_of_accomondation_average: '',
        cost_of_clothing_needs: '',
        cost_of_clothing_average: '',

      }, selectedCategory: '', // Initialize as an empty string
      categoryTitles: {},
      selectedDepartmentCategory: '', // Initialize as an empty string
      departmentCategoryTitlesTitles: {},
      editStates: {}, // Store the editing state separately
      currentEditSpecialty: null,
      currentDeleteSpecialty: null,
      currentEditCategory: null,
      currentDeleteCategory: null,
      budgetTotalEmployees: 0,
      workingDays: 0,
      budgetTotalRelated: 0,
      specialty: {
        total_working_months: '',
        monthly_gross_salary: '',
        // Add other fields as needed
      }

    };
  },
 
  methods: {
    async fetchPayrollData() {
      const response = await getPayrollDepartmentCosts(this.$route.params.budget_id, this.selectedDepartmentCategory);
      if (response.data && response.data.specialties) {
        this.payrollDepartmentCosts = response.data;

        // Initialize dataForm dynamically
        this.dataForm = {};
        this.payrollDepartmentCosts.specialties.forEach(specialty => {
          this.dataForm[specialty.id] = {
            wages_open: specialty.wages_open,
            wages_close: specialty.wages_close,
            average_salary: specialty.average_salary,
            months: {}
          };

          specialty.payroll_costs_specialties.forEach(month => {
            this.dataForm[specialty.id].months[this.getMonthDigit(month.date_from)] = month.wages;
          });
        });
      }
    },
    getTotalWagesDepartment() {
    if (!this.payrollDepartmentCosts || !this.payrollDepartmentCosts.category) return 0;

    // Get opening wages
    const wagesOpen = this.payrollDepartmentCosts.category.total_wages_open || 0;

    // Get closing wages
    const wagesClose = this.payrollDepartmentCosts.category.total_wages_close || 0;

    // Sum all monthly wages
    const totalMonths = (this.payrollDepartmentCosts.category.payroll_costs_categories || []).reduce(
      (sum, payrollCost) => sum + (payrollCost?.total_wages || 0),
      0
    );

    // Final sum
    return wagesOpen + totalMonths + wagesClose;
  },
    editOperationalCategory() {
      this.isEditingOperationalCategory = true;
    },
    cancelEditOperationalCategory() {
      this.isEditingOperationalCategory = false;
    },
    getMonthDigit(dateString) {
      return String(new Date(dateString).getMonth() + 1);
    },
    getFormValues(form) {
        const formData = new FormData(form);
        return Object.fromEntries(formData.entries());
    },

     async fetchRelatedCosts() {
      try {
        const response = await getBudget(this.$route.params.budget_id);
        this.payrollRelatedCosts = response.data.data;
        console.log('this.payrollRelatedCosts:', this.payrollRelatedCosts);

      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },
    async confirmSaveOperationalCategory() {
      let dataForm = this.dataForm;
      const objectKeys = Object.keys(dataForm);
      let newDataForm = {};
      if (objectKeys.length) {
        objectKeys.forEach((k) => {
          let d = dataForm[k];
          if (d.average_salary) {
            d.average_salary =  (d.average_salary + "").replaceAll(',', '.');
          }
          newDataForm[k] = d;
        });
      }
      const r = await updateOperationalCategoryPayrollCost(this.operationalCategory.id, {operationalCategory: this.operationalCategory, dataForm: newDataForm});
      if (r.success) {
        this.isEditingOperationalCategory = false;
        if (this.selectedDepartmentCategory != '' && this.selectedDepartmentCategory != null) {
          this.fetchPayrollData();
        }
        if (this.selectedDepartmentCategory != '' && this.selectedDepartmentCategory != null) {
          this.operationalCategory = (await getOperationalCategory(this.selectedDepartmentCategory)).data;
        }
        if (this.selectedDepartmentCategory && this.selectedDepartmentCategory != '') {
          const r2 = await getDepartmentExpenses(this.$route.params.budget_id, this.selectedDepartmentCategory);
          this.departmentExpenses = r2.data;
        }
        if (this.selectedCategory && this.selectedCategory != '') {
          const r3 = await getEmployeeExpenses(this.$route.params.budget_id, this.selectedCategory);
          this.employeeExpenses = r3.data;
        }
        useToast().success(r.message);
        this.fetchRelatedCosts();
      } else {
        useToast().error(r.message);
      }
    },
    replaceCommasWithDots(obj) {
      // Create a copy of the object to avoid modifying the original proxy directly
      const newObj = { ...obj };

      // Loop through each key in the object
      for (let key in newObj) {
        if (newObj.hasOwnProperty(key)) {
          // Check if the value is a string and looks like a float with comma as decimal separator
          if (typeof newObj[key] === 'string' && newObj[key].match(/^\d{1,3}(.\d{3})*,\d+$/)) {
            // Replace the thousand separators (.) and convert comma to dot for decimals
            newObj[key] = parseFloat(newObj[key].replace(/\./g, '').replace(',', '.'));
          }
        }
      }

      return newObj;
    },
    formatDecimalInput(event, field) {
      // Check if the specialty object is defined
      if (this.specialty && this.specialty[field] !== undefined) {
        // Get the value from the input field
        let value = event.target.value;

        // Replace commas with periods
        value = value.replace(',', '.');

        // Update the value to the correct format
        this.specialty[field] = value;
      } else {
        console.error('specialty or field is undefined');
      }
    },
    // Category methods
    async fetchCategories() {
      try {
        const response = await getCategories(this.$route.params.budget_id);
        this.categories = response.data;

        // Build categoryTitles map
        this.categoryTitles = this.categories.reduce((acc, category) => {
          acc[category.id] = category.title;
          return acc;
        }, {});

        // Set the default selected category to the first category
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[0].id; // Set to the first category's ID
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },

    async fetchDepartmentCategories() {
      try {
        const response = await getDepartmentCategories(this.$route.params.budget_id);
        this.categories = response.data;

        // Build categoryTitles map
        this.departmentCategoryTitles = this.categories.reduce((acc, category) => {
          acc[category.id] = category.title;
          return acc;
        }, {});

        // Set the default selected category to the first category
        if (this.categories.length > 0) {
          this.selectedDepartmentCategory = this.categories[0].id; // Set to the first category's ID
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },

    // Get the month name for a specific date
    getMonthName(date) {
      return new Intl.DateTimeFormat("el-GR", { month: "long" }).format(new Date(date));
    },

   

    formatNumber(value) {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    },
    showAddCategoryForm() {
      this.resetCategoryForm();
      this.showCategoryForm = true;
      this.isEditingCategory = false;
    },
    resetCategoryForm() {
      this.categoryForm = { title: '' };
      this.currentEditCategory = null;
    },
    openCategorySaveModal() {
      $('#categorySaveModal').modal('show');
    },
    closeCategorySaveModal() {
      $('#categorySaveModal').modal('hide');
    },

    async fetchBudgetInfoData() {
      try {
        const response = await fetchBudgetInfo(this.$route.params.budget_id);
        if (response) {
          this.budgetTotalEmployees = response.data.data.total_payroll_cost_employees || 0;
          this.budgetTotalRelated = response.data.data.total_payroll_cost_others || 0;
          this.workingDays = response.data.data.working_days_per_week || 0;

        }
      } catch (error) {
        console.error('Failed to fetch budget info:', error);
      }
    },
    async confirmSaveCategory() {
      try {
        const form = { title: this.categoryForm.title };
        if (this.isEditingCategory && this.currentEditCategory) {
          const response = await updateCategory(this.currentEditCategory.id, form);
          if (response.success) {
            useToast().success(response.message);
          } else {
            useToast().error(response.message);
          }
          this.currentEditCategory.title = form.title;
          this.editStates[this.currentEditCategory.id] = false;
        } else {
          const response = await createCategory(this.$route.params.budget_id, form);
          if (response.success) {
            useToast().success(response.message);
          } else {
            useToast().error(response.message);
          }
          this.categories.push(response.data);
        }
        this.fetchCategories();
        this.fetchRelatedCosts();
        this.resetCategoryForm();
        this.closeCategorySaveModal();
        this.fetchBudgetInfoData();
        this.showCategoryForm = false;
        if (this.selectedDepartmentCategory && this.selectedDepartmentCategory != '') {
          const r2 = await getDepartmentExpenses(this.$route.params.budget_id, this.selectedDepartmentCategory);
          this.departmentExpenses = r2.data;
        }
        if (this.selectedCategory && this.selectedCategory != '') {
          const r3 = await getEmployeeExpenses(this.$route.params.budget_id, this.selectedCategory);
          this.employeeExpenses = r3.data;
        }
      } catch (error) {
        console.error('Error saving category:', error);
        this.closeCategorySaveModal();
      }
    },
    async confirmSaveRelatedCosts() {
      try {
        // Construct the form object
        const form = {
          cost_of_accomondation_food_needs: (this.payrollRelatedCosts.cost_of_accomondation_food_needs + "").replaceAll(",", "."),
          cost_of_accomondation_average: (this.payrollRelatedCosts.cost_of_accomondation_average + "").replaceAll(",", "."),
          cost_of_clothing_needs: (this.payrollRelatedCosts.cost_of_clothing_needs + "").replaceAll(",", "."),
          cost_of_clothing_average: (this.payrollRelatedCosts.cost_of_clothing_average + "").replaceAll(",", "."),
          working_days_per_week: this.workingDays,
        };

        // Make the API call to save data
        const response = await updatePayrollRelatedCosts(this.$route.params.budget_id, form);
        if (response.data.success) {
          useToast().success(response.data.message);
        } else {
          useToast().error(response.data.message);
        }

        // Reset the editing state and fetch data
        this.isEditingRelatedCosts = false; // Close the edit mode after saving
        this.fetchSpecialties();
        this.closeRelatedSaveModal();
        this.resetForm();
        this.fetchBudgetInfoData();
        this.fetchCategories();
        this.fetchDepartmentCategories();
        this.fetchRelatedCosts();

        this.showForm = false; // Close the form after saving
        if (this.selectedDepartmentCategory && this.selectedDepartmentCategory != '') {
          const r2 = await getDepartmentExpenses(this.$route.params.budget_id, this.selectedDepartmentCategory);
          this.departmentExpenses = r2.data;
        }
        if (this.selectedCategory && this.selectedCategory != '') {
          const r3 = await getEmployeeExpenses(this.$route.params.budget_id, this.selectedCategory);
          this.employeeExpenses = r3.data;
        }
      } catch (error) {
        console.error("Error saving related costs:", error);
        useToast().error("An error occurred while saving the related costs.");
        this.closeRelatedSaveModal();
      }
    },

    editCategory(category) {
      this.currentEditCategory = category;
      this.categoryForm.title = category.title;
      this.editStates = { ...this.editStates, [category.id]: true };
      this.isEditingCategory = true;
    },
    cancelEditCategory(category) {
      this.editStates[category.id] = false;
      this.resetCategoryForm();
    },

    // Specialty methods
    async fetchSpecialties() {
      try {
        const response = await getSpecialties(this.$route.params.budget_id);
        this.specialties = response.data;
      } catch (error) {
        console.error('Error fetching specialties:', error);
      }
    },
    showAddSpecialtyForm() {
      this.resetForm();
      this.showForm = true;
      this.currentEditSpecialty = null; // Reset any previous edits
    },
    resetForm() {
      this.form = {
        title: '',
        employee_category_id: null,
      };
      this.currentEditSpecialty = null; // Reset the edit state
    },
    openSpecialtySaveModal(ev, specialty = null) {
      if (specialty) {
        // Applying the method to the raw object values of the specialty
        this.currentEditSpecialty = this.replaceCommasWithDots({ ...specialty });
      } else {
        this.currentEditSpecialty = null; // Ensure null when creating a new specialty
      }
      $('#specialtySaveModal').modal('show');
    },
    openRelatedCostsSaveModal(ev) {
      $('#relatedSaveModal').modal('show');
    },
    closeSpecialtySaveModal() {
      $('#specialtySaveModal').modal('hide');
    },
    closeRelatedSaveModal() {
      $('#relatedSaveModal').modal('hide');
    },
    async confirmSaveSpecialty() {
      try {
        if (!this.currentEditSpecialty) {
          // Create a new specialty
          let formattedForm = this.replaceCommasWithDots(this.form);
          const response = await createSpecialty(this.$route.params.budget_id, formattedForm);

          if (response.success) {
            useToast().success(response.message);
            this.specialties.push(response.data); // Add the new specialty to the list
          } else {
            useToast().error(response.message);
          }
        } else {
          // Update existing specialty
          let formattedSpecialty = this.replaceCommasWithDots(this.currentEditSpecialty);
          const response = await updateSpecialty(formattedSpecialty.id, formattedSpecialty);

          if (response.success) {
            useToast().success(response.message);
          } else {
            useToast().error(response.message);
          }
          this.editStates[this.currentEditSpecialty.id] = false; // Close edit mode after saving
        }
        if (this.selectedDepartmentCategory && this.selectedDepartmentCategory != '') {
          const r2 = await getDepartmentExpenses(this.$route.params.budget_id, this.selectedDepartmentCategory);
          this.departmentExpenses = r2.data;
        }
        if (this.selectedCategory && this.selectedCategory != '') {
          const r3 = await getEmployeeExpenses(this.$route.params.budget_id, this.selectedCategory);
          this.employeeExpenses = r3.data;
        }
        await this.fetchSpecialties();
        this.closeSpecialtySaveModal();
        this.resetForm();
        await this.fetchBudgetInfoData();
        this.showForm = false; // Close form after saving
      } catch (error) {
        console.error('Error saving specialty:', error);
        this.closeSpecialtySaveModal();
      }
    },

    editSpecialty(specialty) {
      this.editStates = { ...this.editStates, [specialty.id]: true };
      this.currentEditSpecialty = specialty;
    },
    editRelatedCosts() {
      this.isEditingRelatedCosts = true;
    },
    cancelEditSpecialty(specialty) {
      this.editStates[specialty.id] = false;
      this.currentEditSpecialty = null; // Reset the edit state
    },
    cancelEditRelatedCosts() {
      this.isEditingRelatedCosts = false;
    }
  },
  async mounted() {
    useHead({
      title: 'Payroll Costs',
    });
    this.fetchCategories();
    this.fetchDepartmentCategories();
    this.fetchRelatedCosts();
    this.fetchSpecialties();
    this.fetchBudgetInfoData();
    const r1 = await getEmployeeExpenses(this.$route.params.budget_id, );
    this.employeeExpenses = r1.data;
  },
  watch: {
    selectedDepartmentCategory: {
      immediate: true,
      async handler() {
        if (this.selectedDepartmentCategory != '' && this.selectedDepartmentCategory != null) {
          this.fetchPayrollData();
          this.operationalCategory = (await getOperationalCategory(this.selectedDepartmentCategory)).data;
          const r2 = await getDepartmentExpenses(this.$route.params.budget_id, this.selectedDepartmentCategory);
          this.departmentExpenses = r2.data;
        }
      }
    },
    selectedCategory: {
      immediate: true,
      async handler() {
        if (this.selectedCategory != '' && this.selectedCategory != null) {
          const r2 = await getEmployeeExpenses(this.$route.params.budget_id, this.selectedCategory);
          this.employeeExpenses = r2.data;
        }
      }
    }
  }
};
</script>

<style scoped>
.form-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.card {
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ddd;
  position: relative;
  margin-left: 35px;
}

.action-buttons {
  position: absolute;
  top: 100px;
  right: 10px;
}

.label-with-circle::before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #a6a6a6;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: middle;
}

.label-with-circle2::before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: var(--primary-color);
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: middle;
}

.align-middle {
  margin-top: 30px;
}

.shadow-custom {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.shadow-custom:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 12px 40px rgba(0, 0, 0, 0.2);
}

.edit {
  position: absolute;
  top: 25%;
  /* Adjust the vertical position to be slightly above middle */
  right: -30px;
  /* Half the button outside the outlet-card */
  transform: translateY(-180%);
  /* Center vertically relative to its position */
}

.save {
  position: absolute;
  top: 25%;
  /* Adjust as needed to lower the button */
  right: -30px;
  /* Adjust to move outside the card */
  transform: translateY(-180%);
  /* Further adjust for desired position */
}

.save2 {
  position: absolute;
  top: 11%;
  /* Adjust as needed to lower the button */
  right: -15px;
  /* Adjust to move outside the card */
  transform: translateY(-180%);
  /* Further adjust for desired position */
}

.delete {
  position: absolute;
  top: 50%;
  /* Adjust to position higher or lower */
  right: -18px;
  /* Same as above */
  transform: translateY(30%);
  /* Further adjust for desired position */
}

.tabs-container .btn {
  font-weight: bold;
  border-radius: 5px;
  padding: 10px 20px;
}

.tabs-container .btn.active {
  background-color: #0056b3;
  color: white;
}
</style>